











































































import { Vue, Component } from 'vue-property-decorator';
import { Divider, Icon } from 'vant';
import { Eventbus } from './eventBus';

import { fetchLeader, fetchTopics, fetchNews } from './api';
Vue.use(Divider).use(Icon);
@Component
export default class Desk extends Vue {
  showVideoVal: boolean = false;
  leaderData: any = {};
  topicData: any = {};
  newsData: any = {};
  videoSrc: string = '';
  copyList: boolean = true;
  scrolltimer: any = '';
  created() {
    this.fetchData();
  }
  async fetchData() {
    const res = await fetchLeader();
    const topic = await fetchTopics();
    const news = await fetchNews();
    this.topicData = topic.data;
    this.leaderData = res.data;
    this.newsData = news.data;
  }
  mounted() {
    this.scrolltimer = setInterval(() => this.rollStart(), 50);
    window.addEventListener('resize', () => {
      const wrap = this.$refs.scrollWarp;
      clearInterval(this.scrolltimer);
      (wrap as HTMLElement).scrollTop = 0;
      this.scrolltimer = setInterval(() => this.rollStart(), 50);
    });
  }
  rollStart() {
    const wrap = this.$refs.scrollWarp;
    const scrollBox = this.$refs.scrollBox;
    const copyBox = this.$refs.copyBox;
    if (
      (wrap as HTMLElement).scrollHeight / 2 <
      (scrollBox as HTMLElement).scrollHeight
    ) {
      this.copyList = false;
    } else {
      if (
        (wrap as HTMLElement).scrollTop ===
        Math.floor((scrollBox as HTMLElement).scrollHeight)
      ) {
        (wrap as HTMLElement).scrollTop = 0;
      } else {
        (wrap as HTMLElement).scrollTop++;
      }
    }
  }

  handlePlayClick(video: string) {
    Eventbus.$emit('stop', false);
    this.showVideoVal = true;
    this.videoSrc = this.leaderData[video];

  }
  handleCloseClick() {
    Eventbus.$emit('startPlay', true);
    this.showVideoVal = false;
  }

  destroyed() {
    clearInterval(this.scrolltimer);
  }
}
